import { VillageCreatePage } from "@/features/geolocation/page/VillageCreatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/village/create")({
  component: VillageCreatePage,
});
